"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "next/navigation";
import { useSession } from "next-auth/react";
import { menuSectionsBottom, menuSectionsTop } from "@/config/navigation";
import { useActiveProject } from "@/context/active-project";
import {
  isActiveProjectSettled,
  menuClaimsForScopedProjects,
} from "@/lib/auth/session-menu-claims";
import {
  CLAIM_GATED_ROUTE_FALLBACK_PATH,
  isClaimGatedPathDisallowed,
} from "@/lib/claims/menu-filter";

const sidebarSections = [...menuSectionsTop, ...menuSectionsBottom];

/**
 * UX-only redirect after the page has rendered. A gated page can flash and its data
 * calls can still run. That is accepted; this guard does not enforce claims on the server.
 */
export const ClaimedRouteGuard = () => {
  const pathname = usePathname();
  const router = useRouter();
  const { data: session, status } = useSession();
  const { activeProjectId, projects } = useActiveProject();

  useEffect(() => {
    if (status !== "authenticated") return;
    if (!isActiveProjectSettled(projects, activeProjectId)) return;
    if (pathname === CLAIM_GATED_ROUTE_FALLBACK_PATH) return;

    const menuClaims = menuClaimsForScopedProjects(session ?? null, activeProjectId, projects);
    if (!isClaimGatedPathDisallowed(pathname, menuClaims, sidebarSections)) return;

    router.replace(CLAIM_GATED_ROUTE_FALLBACK_PATH);
  }, [status, projects, activeProjectId, pathname, session, router]);

  return null;
};
